import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { OnboardingStatus } from 'src/app/core/enum/OnboardingStatus';
import { endpoints } from 'src/environments/endpoints';
import { BeneficiarioStatus } from '../../models/onboarding/BeneficiarioStatus';
import { BeneficioStatus } from '../../models/onboarding/BeneficioStatus';
import { ContratoStatus } from '../../models/onboarding/ContratoStatus';
import { EmpresaStatus } from '../../models/onboarding/EmpresaStatus';

@Injectable({
  providedIn: 'root',
})
export class OnboardingService {
  http = inject(HttpClient);

  private baseUrl = endpoints.onboarding;

  initOnboarding(): Observable<OnboardingStatus> {
    return this.http.put<OnboardingStatus>(this.baseUrl, {
      etapa: 1,
    });
  }

  updateOnboarding(etapa: OnboardingStatus): Observable<void> {
    return this.http.put<void>(this.baseUrl, {
      etapa,
    });
  }

  getBeneficiosStatus(): Observable<BeneficioStatus> {
    const url = `${this.baseUrl}/passoUm`;

    return this.http.get<BeneficioStatus>(url);
  }

  getEmpresaStatus(): Observable<EmpresaStatus> {
    const url = `${this.baseUrl}/passoDois`;

    return this.http.get<EmpresaStatus>(url);
  }

  getContratoStatus(): Observable<ContratoStatus> {
    const url = `${this.baseUrl}/passoTres`;

    return this.http.get<ContratoStatus>(url);
  }

  getBeneficiarioStatus(): Observable<BeneficiarioStatus> {
    const url = `${this.baseUrl}/passoQuatro`;

    return this.http.get<BeneficiarioStatus>(url);
  }
}
